<template>
  <div>
    <form @submit.prevent>
      <h2>
        <span v-if="isEditMode">{{ $t("datasubject.name") }} "{{ editedEntity.name | translate }}" {{ $t("common.update") }}</span>
        <span v-else>{{ $t("datasubject.new") }}</span>
      </h2>

      <sweet-input
        v-model="form.name"
        :isValid="!$v.form.name.$error"
        @input="$v.form.name.$touch()"
        layout="vertical"
        :placeholder="$t('datasubject.name')"
        :label="$t('datasubject.name')"
      />

      <div class="col-mr-5 mt-3">
        <right-panel
          class="float-right mt-1 "
          id="sidebar-new-datasubject-category"
          width="650px"
          :icon="'mdi mdi-plus'"
          :text="$t('datasubject-category.new')"
          @hidden="rightPanelClosed"
        >
          <div class="pl-5 pr-5">
            <Form :hide-library="true" @onSave="onCategorySelect" />
          </div>
        </right-panel>
      </div>

      <h6 class="mt-4">{{ $t("datasubject-category.name") }}</h6>
      <filter-select
        :validation="true"
        :isValid="!$v.form.category.$invalid"
        id="categoryFilter"
        ref="categoryFilter"
        :placeholder="$t('datasubject-category.text')"
        :multiple="false"
        @filter="onCategorySearch"
        :selected="form.category"
        @changed="onCategorySelect"
      />

      <h6 class="mt-4">{{ $t("sector.name") }}</h6>
      <filter-select
        id="sectorFilter"
        ref="sectorFilter"
        :placeholder="$t('sector.text')"
        :multiple="false"
        @filter="onSectorSearch"
        :selected="form.sector"
        @changed="onSectorSelect"
      />
      <br />
      <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
        {{ $t("common.save") }}
      </sweet-button>
    </form>
  </div>
</template>

<script>
import Form from "./management-library-datasubject-category-form.vue";

import { maxLength, minLength, required } from "vuelidate/lib/validators";
const state = "managementDatasubject";

export default {
  components: {
    Form,
  },
  data() {
    return {
      form: {
        name: undefined,
        category: undefined,
      },
      formError: undefined,
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },
      category: {
        required,
      },
    },
  },

  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`${state}/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`${state}/isEditMode`];
    },
  },
  mounted() {},
  methods: {
    async save() {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${state}/save`, this.form);
        this.form = {};
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    rightPanelClosed() {
      this.$refs.categoryFilter.reset();
    },

    async onCategorySearch(value, callback) {
      const response = await this.$store.dispatch(`managementDatasubjectCategory/paginate`, {
        options: { limit: 200 },
        query: { name: { value }, "scope.value": { value: "system", isObject: true } },
      });
      callback(response.data?.docs ?? []);
    },
    onCategorySelect(category) {
      this.form = { ...this.form, category };
    },
    async onSectorSearch(value, callback) {
      const response = await this.$store.dispatch(`managementSector/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });
      callback(response.data?.docs ?? []);
    },
    onSectorSelect(item) {
      this.form = { ...this.form, sector: item };
    },
  },
};
</script>
